const frontendVersion = process.env.REACT_APP_VERSION || require('../../package.json').version;

export const getVersion = () => {
    return {
        full: frontendVersion
    };
}; 